import React, { useEffect } from 'react';
import { useNavigate, Routes, Route, Link, useLocation } from 'react-router';
import { useAuth } from '../../../context/AuthContext';
import Overview from './overview/Overview';
import BookingsManagement from './bookingsManagement/BookingsManagement';
import CalendarManagement from './calendarManagement/CalendarManagement';
import UsersManagement from './users/UsersManagement';
import GiftCardsManagement from './giftCardsManagement/GiftCardsManagement';
import Settings from './settings/Settings';
import Loading from '../../../components/common/Loading';
import './AdminDashboard.css';

const AdminDashboard = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { currentUser, userRole, userName, loading } = useAuth();

  useEffect(() => {
    if (loading) return;

    if (!currentUser) {
      navigate('/signin', { replace: true });
      return;
    }

    // Check if user has admin access
    if (userRole !== 'admin') {
      console.log('Access denied: User is not an admin');
      navigate('/user');
    }
  }, [currentUser, userRole, loading, navigate]);

  if (loading) {
    return <Loading />;
  }

  if (!currentUser || userRole !== 'admin') {
    return null;
  }

  // Helper function to check if a path is active
  const isPathActive = (path) => {
    return location.pathname === `/admin${path}`;
  };

  return (
    <div className="admin-dashboard">
      <div className="admin-dashboard__sidebar">
        <div className="admin-dashboard__logo">
          <h2>Admin Panel</h2>
        </div>
        <nav className="admin-dashboard__nav">
          <Link 
            to="/admin"
            className={`admin-dashboard__nav-item ${isPathActive('') ? 'active' : ''}`}
          >
            <span className="nav-icon">📊</span>
            Overview
          </Link>
          <Link 
            to="/admin/bookings"
            className={`admin-dashboard__nav-item ${isPathActive('/bookings') ? 'active' : ''}`}
          >
            <span className="nav-icon">📅</span>
            Bookings
          </Link>
          <Link 
            to="/admin/calendar"
            className={`admin-dashboard__nav-item ${isPathActive('/calendar') ? 'active' : ''}`}
          >
            <span className="nav-icon">🗓️</span>
            Calendar
          </Link>
          <Link 
            to="/admin/users"
            className={`admin-dashboard__nav-item ${isPathActive('/users') ? 'active' : ''}`}
          >
            <span className="nav-icon">👥</span>
            Users
          </Link>
          <Link 
            to="/admin/gift-cards"
            className={`admin-dashboard__nav-item ${isPathActive('/gift-cards') ? 'active' : ''}`}
          >
            <span className="nav-icon">🎁</span>
            Gift Cards
          </Link>
          <Link 
            to="/admin/settings"
            className={`admin-dashboard__nav-item ${isPathActive('/settings') ? 'active' : ''}`}
          >
            <span className="nav-icon">⚙️</span>
            Settings
          </Link>
        </nav>
      </div>
      
      <div className="admin-dashboard__main">
        <div className="admin-dashboard__header">
          <h1>Welcome, {userName}</h1>
        </div>
        <div className="admin-dashboard__content">
          <Routes>
            <Route index element={<Overview />} />
            <Route path="bookings" element={<BookingsManagement />} />
            <Route path="calendar" element={<CalendarManagement />} />
            <Route path="users" element={<UsersManagement />} />
            <Route path="gift-cards" element={<GiftCardsManagement />} />
            <Route path="settings" element={<Settings />} />
          </Routes>
        </div>
      </div>
    </div>
  );
};

export default AdminDashboard; 